import { render } from "./ReportParams.vue?vue&type=template&id=24162370&scoped=true"
import script from "./ReportParams.vue?vue&type=script&lang=ts"
export * from "./ReportParams.vue?vue&type=script&lang=ts"

import "./ReportParams.vue?vue&type=style&index=0&id=24162370&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24162370"

export default script